import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/membershipLengthSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import AgreementStatusFilter from "./smartComponents/AgreementStatusFilter";
import ModuleLogicSwitcher from "./smartComponents/ModuleLogicSwitcher";
import SalesPackageFilter from "./smartComponents/SalesPackageFilter";
import MemberStatusFIlter from "./smartComponents/MemberStatusFIlter";
import MembershipTypes from "./smartComponents/MembershipTypes";
import PieChart from "../../../components/charts/pieChart/pieChart";
import AgreementTable from "./smartComponents/AgreementTable";
import CategoryFilter from "./smartComponents/CategoryFilter";
import GroupByFilter from "./smartComponents/GroupByFilter";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { DataPoints } from "./smartComponents/DataPoints";
import Type from "./smartComponents/Type";
import { useDateFormat } from "../../../hooks/useDateFormat";
import { MODULE_LOGICS } from "./constants";

import NoData from "../../../components/noData/noData";
import "./membershipLength.scss";

const MembershipLengthModule = (props) => {
  const dispatch = useDispatch();
  const { updatesLoading, initialRequest, isLoading } = useSelector(
    (state) => state.membershipLengthByAgreement
  );
  const dateFormat = useDateFormat();

  const { useSecondaryCategories } = useSelector((state) => state.commonReducer.commonProps);
  const typeFilter = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.type.id
  );
  const selectedModuleLogic = useSelector(
    (state) => state.membershipLengthByAgreement.selectedModuleLogic.id
  );
  const pie_charts = useSelector((state) => state.membershipLengthByAgreement.table.pie_charts);
  const hasSelectedAgreementLogic = selectedModuleLogic === MODULE_LOGICS.AGREEMENTS;

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              {hasSelectedAgreementLogic ? (
                <>
                  <AgreementStatusFilter />
                  <Type />
                  {typeFilter === "membership_type" ? (
                    <MembershipTypes />
                  ) : useSecondaryCategories ? (
                    <>
                      <CategoryFilter />
                      <SalesPackageFilter />
                      <GroupByFilter />
                    </>
                  ) : (
                    <SalesPackageFilter />
                  )}
                </>
              ) : (
                <MemberStatusFIlter />
              )}
            </div>
            <ReactDatePicker
              displayFormat={dateFormat}
              calendarEndDate={props.calendarEndDate}
              disabled
              startDate={props.calendarEndDate}
            />
            <UpdateBtns params={props} />
          </div>
        </div>

        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : pie_charts?.length ? (
          <>
            <div className={`chart-container ${hasSelectedAgreementLogic ? "" : "double-charts"}`}>
              <DataPoints />
              <div className="pie-charts">
                {pie_charts.map((chart, idx) => (
                  <div key={chart.title || idx} className="pie-chart">
                    {chart?.title && <h5 className="pie-chart__title">{chart.title}</h5>}
                    <PieChart
                      width={600}
                      isSortable={false}
                      showPercent
                      height={hasSelectedAgreementLogic ? 300 : 350}
                      customTooltip
                      responsive={false}
                      data={chart.data}
                      showLegend
                      isLegendTooltip
                      legendPosition="right"
                    />
                  </div>
                ))}
              </div>
            </div>
            <AgreementTable />
          </>
        ) : (
          <NoData />
        )}
      </div>
    );
  };
  return (
    <div id="membershipLength">
      <SectionToggle
        title="Membership Length by"
        isLoading={isLoading}
        content={content()}
        autoHeight
        learnMore={
          <>
            <ModuleLogicSwitcher />
            <KBLearnMore
              title="Membership Length"
              description="This report shows how long members remain active on a specific agreement, using the membership start date as the entry point. These insights help you evaluate contract longevity, identify retention strengths, and understand how membership duration trends change over time."
              kbUrl={ILEARN_URLS.ltvAndLength.membershipLength}
            />
          </>
        }
      />
    </div>
  );
};

export default React.memo(MembershipLengthModule);
